// ----------------------------------------------------------------------------
// Template: Account
// ----------------------------------------------------------------------------
// 
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'sections/header/header';
import 'sections/footer/footer';

// Styles
import './_account.scss';

$(document).ready(function(){

	$('#dental-profession').on('change', function(){

		if($("#customer-role-tag").length) {
			$("#customer-role-tag").val($('#dental-profession').val());
		}
	})

    $("#customer-edit__button").on('click', function(){
        $('#customer-edit__form').toggle();
    })

	var e = $("#customer_metafields"),
        t = $("#customer_metafields_edit");
    if (e.length) {
        var i = e.find("#dental-profession"),
            n = e.find("#office-phone");
        (s = e.find('input[type="submit"]')).on("click", function () {
            i[0].checkValidity() && n[0].checkValidity() && s.val("Submitting...");
        }),
            Accentuate(e, function (e) {
                s.val("Success! Redirecting...").addClass("button--success"), "OK" === e.status && "Fields updated" === e.message ? setTimeout(window.location.reload.bind(window.location, !0), 2e3) : console.warn(e);
            });
    }
    if (t.length) {
        var s = t.find('input[type="submit"]');
        console.log(s),
            Accentuate(t, function (e) {
                s.val("Success").addClass("button--success"), "OK" === e.status && "Fields updated" === e.message ? setTimeout(window.location.reload.bind(window.location, !0), 500) : console.warn(e);
            });
    }
})
